import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../actions';
import logo from './hippalus2-small.png';
import s from './landingPage.module.css';

const { requestDatasets } = actions;

const LandingPage = () => {
  const dispatch = useDispatch();
  const { datasets } = useSelector(state => ({
    datasets: state.datasets
  }));


  useEffect(
    () => {
      // prefetch datasets here for next screen
      if (!datasets) dispatch(requestDatasets());
    }, [datasets, dispatch]
  );

  return (
    <div className='text-center'>
      <img className={s.img} src={logo} alt='hippalus-logo' />
      <p>Preference-enriched Faceted Search</p>
      <Link to='/datasets'>
        <Button variant='secondary'>Enter to Explorable Datasets</Button>
      </Link>
    </div>
  );

};

LandingPage.defaultProps = {
  datasets: null,
};

LandingPage.propTypes = {
  datasets: PropTypes.objectOf(PropTypes.object),
};

export default LandingPage;
